import React, { useState, useEffect } from 'react'
import { Subheader } from '../../../components/Page/logix2020/Subheader'
import { useTranslation } from 'react-i18next'
import { Alert, Spinner } from 'react-bootstrap'
import EditAssetGroupsTree from '../../../components/Configuration/AssetGroups/EditAssetGroupsTree'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import { SidebarLeft } from '../../../components/Page/logix2020/SidebarLeft'
import BigFooter from '../../../components/Footer/BigFooter'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'
import { Link } from 'react-router-dom'
import AdministrationSidebarNavigation from '../../../components/Configuration/AdministrationSidebarNavigation'
import useStores from '../../../stores/useStore'
import { MdLibraryAdd } from 'react-icons/md'
import { navigationSideLeft } from '../../../pages/Configuration/AdministrationPage'
import AdministrationSidebar from '../../../components/Configuration/AdministrationSidebar'

const AssetGroupsAdministrationPageContent = () => {
  const { t } = useTranslation()

  return (
    <div>
      <Subheader className="subHeader-v1 justify-content-between">
        <div className="subheader-title">{t('assetGroups:manageAssetGroups')}</div>
        <div className="subheader__buttonWrapper">
          <Link to="/assetGroupsAdministration/create#general" className="subheader__button btn btn-primary text-white"><MdLibraryAdd className="me-3" />{t('assetGroups:addAssetGroup')}</Link>
        </div>
      </Subheader>
      <FlexWrapper>
        <SidebarLeft>
          <AdministrationSidebarNavigation active="assetGroupsAdministration" />
        </SidebarLeft>
        <ContentArea>
          <EditAssetGroupsTree />
        </ContentArea>
      </FlexWrapper>
      <BigFooter />
    </div >
  )
}

const AssetGroupsAdministrationPage = () => {

  const { t } = useTranslation()
  const { uiStore } = useStores()
  const [error, setError] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setError(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {!uiStore.allowAssetManagementAdministration ? (
        <>
          <Subheader className="subHeader-v1 justify-content-between">
            <div className="subheader-title">{t('assetGroups:manageAssetGroups')}</div>
          </Subheader>
          <FlexWrapper>
            <SidebarLeft>
              {/* <AdministrationSidebarNavigation active="assetGroupsAdministration" /> */}
              <AdministrationSidebar options={navigationSideLeft()} active="assetGroupsAdministration" />

            </SidebarLeft>
            <ContentArea>
              {error
                ? <Alert variant="danger">{t('accessDenied')}</Alert>
                : <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
              }
            </ContentArea>
          </FlexWrapper>
          <BigFooter />
        </>
      ) : <AssetGroupsAdministrationPageContent />
      }
    </>
  )
}
export default AssetGroupsAdministrationPage
